import React from 'react';
import { DateTimeInput, DateTimeInputProps } from 'react-admin';

const SmartDateTimeInput = (props: DateTimeInputProps) => {
  const { inputProps, ...rest } = props;

  const enhancedInputProps = {
    max: '9999-12-31T23:59',
    ...inputProps,
  };

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <DateTimeInput {...rest} inputProps={enhancedInputProps} />;
};

export default SmartDateTimeInput;
